<template>
  <div v-if="file && file.path" class="pdf-preview">
    <div v-if="!isPdf" class="non-pdf-warning">
      This file is not a PDF; preview may not render correctly.
    </div>
    <iframe :src="file.path" :height="height" class="pdf-frame"></iframe>
    <a :href="file.path" target="_blank" rel="noopener" class="download-link">
      <i class="el-icon-download"></i> Download PDF
    </a>
  </div>
</template>

<script>
export default {
  name: 'PdfPreview',
  props: {
    file: {
      type: Object,
      required: false
    },
    height: {
      type: Number,
      required: false,
      default: 400
    }
  },
  computed: {
    isPdf () {
      if (!this.file || !this.file.contentType) return true
      return this.file.contentType.toLowerCase().indexOf('pdf') !== -1
    }
  }
}
</script>

<style lang="scss" scoped>
  .pdf-preview {
    margin-top: 15px;
  }

  .pdf-frame {
    width: 100%;
    border: 1px solid $border;
    border-radius: 4px;
  }

  .download-link {
    display: inline-flex;
    align-items: center;
    margin-top: 8px;
    font-size: 12px;
    color: #008fcc;
    text-decoration: none;

    i {
      margin-right: 4px;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  .non-pdf-warning {
    background-color: #fdf6ec;
    border: 1px solid #faecd8;
    color: #e6a23c;
    padding: 6px 10px;
    font-size: 12px;
    border-radius: 4px;
    margin-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/station/Certification/PdfPreview.vue